import QuestionCard from "elements/QuestionCard";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

const HasPortalAccount = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<QuestionCard
				id="hasPortalAccount"
				value={specialFieldsValue?.has_ny_gov_id_account}
				setValue={(v?: boolean) =>
					setSpecialFieldsValue({ has_ny_gov_id_account: v })
				}
				tooltipText=""
				question="Do you already have a Tax.NY.gov ID account?"
				subTitle="This information is necessary in order to process and file your exemption on your behalf."></QuestionCard>
			{specialFieldsValue?.has_ny_gov_id_account === false && (
				<p className="sm exemptions-notification-message-azure">
					We will create a Tax.NY.gov ID account on your behalf and share your
					credentials with you afterwards. You may receive a confirmation email
					from Tax.NY.gov after we've created your account.
				</p>
			)}
			<ButtonV2
				size="large"
				disabled={specialFieldsValue?.has_ny_gov_id_account === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default HasPortalAccount;
